export enum OperationType {
  READ = "READ",
  EDIT= "EDIT"
}